module.exports = __webpack_public_path__ + "img/3bombas.1505904e.jpg";